import { SearchTerm } from './SearchTerm';

const CompanySearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "compName",
        translationKey: "name"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    },
];

export default CompanySearch;
